export enum UserSettingsMenuType {
    Account = "Account",
    Notifications = "Notifications"
}
